import React from 'react'

function LiForOptions({option}) {
  return (
    <>{option}</>
  )
}

export default LiForOptions